
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {Signal} from '@preact/signals-core';
import {Container} from 'pixi.js';

export class SignalEventsHandler<T extends {}>{
    readonly eventsToHandle: (keyof T)[] = [];

    constructor() {}

    handleEvents<
        K extends keyof T
    >(keys: readonly K[]): this {
        this.eventsToHandle.push(...keys);

        return this;
    }

    apply(props: T|Signal<T>, obj: Container): () => void {
        let prevCallbacks: any[] = [];
        const isSignal = this.isSignal(props);

        return Store.effect(() => {
            const propsVal: T = isSignal ? (props as any as Signal<T>).value : props as T;

            this
                .getEventKeysToHandle(propsVal)
                .map(key => {
                    const val = propsVal[key];

                    const isArray = Array.isArray(val);
                    const callbacks = isArray ? val : [val];

                    prevCallbacks.forEach(cb => {
                        obj.off(key as string, cb);
                    });

                    callbacks.forEach(cb => {
                        obj.on(key as string, cb);
                    });

                    prevCallbacks = callbacks;
                });
        });
    }

    private getEventKeysToHandle(props: T): (keyof T)[] {
        return this.eventsToHandle
            .filter(key => Object.prototype.hasOwnProperty.call(props, key));
    }

    private isSignal(val: any) {
        return Store.isSignal(val);
    }
}